import { PayPalNVP } from 'src/pages/paypalnvp/paypal-nvp';

import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { PlatformLocation, CurrencyPipe } from '@angular/common'
import { DomSanitizer } from '@angular/platform-browser';
import { NgForm, FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage-angular';
import { Router } from '@angular/router';


import { ToastController } from 'src/app/components/ionic-replacements/ToastController';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { OrderProviderExtender } from '../../providers/order/order-extender';
import { TouchcrApiOrderformProvider } from '../../providers/touchcr-api-orderform/touchcr-api-orderform';
import { CartProvider } from '../../providers/cart/cart';
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { TouchcrApiLeadProvider } from '../../providers/touchcr-api-lead/touchcr-api-lead';
import { TouchcrApiCouponProvider } from '../../providers/touchcr-api-coupon/touchcr-api-coupon';
import { OrderDetailsProvider } from '../../providers/order-details/order-details';
import { TouchcrApiShippingProvider } from '../../providers/TouchcrApiShippingProvider';
import { CalculateProvider } from '../../providers/calculate/calculate';
import { UrlsProvider } from 'src/app/providers/urls';
import { OrderProvider } from 'src/app/providers/order/order';
import { GeneralProvider } from 'src/app/providers/general';
import { LoggingProvider } from 'src/app/providers/logging';
import { SpinnerProvider } from '../../providers/spinner/spinner';
import { TouchcrApiGeneralExtenderProvider } from '../../providers/touchcr-api-general/touchcr-api-general-extender';
import { TouchcrApiOrderExtenderProvider } from '../../providers/touchcr-api-order/touchcr-api-order-extender';
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { PaypalPaymentExtenderProvider } from '../../providers/paypal/paypal-extender';
import { StateProvider } from 'src/app/providers/state';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings';
import { Country } from '../../models/country';
import { CHECKOUT_LABEL, PAYMENT_LABEL, SHIPPING_LABEL } from 'src/constants/constants';
import { DynamicCurrencyPipe } from 'src/app/shared/pipes/dynamic-currency.pipe';
import { CheckoutCommon } from '../_brand-pages-base/base-controllers/checkout/checkout-common';
import { BRAND_BASE_URL, CDN_BASE_URL, EXTERNAL_URLS, CDN_IMAGES, CUSTOMER_SERVICE_PHONE_NUMBER } from 'src/constants/param-constants';
import { CookieUtils } from 'src/app/shared/utils/cookie-utils';

@Component({
  selector: 'checkout-common-tc',
  templateUrl: './checkout-commonTC.html',
  styleUrls: ['./checkout-commonTC.scss']
})
export class CheckoutCommonTC extends CheckoutCommon {
  public override isSelectedCB2: boolean = true;
  override iconPaypal: string = EXTERNAL_URLS.PAYPAL_BUTTON_LARGE;
  override BRAND_BASE_URL = BRAND_BASE_URL;
  override CDN_BASE_URL = CDN_BASE_URL;
  override CDN_IMAGES = CDN_IMAGES;
  public CUSTOMER_SERVICE_PHONE_NUMBER = CUSTOMER_SERVICE_PHONE_NUMBER;

  // Timer properties
  public minutes: string = '00';
  public secondsTens: string = '0';
  public secondsOnes: string = '0';
  private timerInterval: any;
  private totalTimeInSeconds: number = 300; // 5 minutes
  private timerDate: any;
  private nowsDate: Date;
  public trialDays: number = 21;
  constructor(
    public override navCtrl: NavControllerExt,
    public override sanitizer: DomSanitizer,
    public override tcrApiOrderform: TouchcrApiOrderformProvider,
    public override cart: CartProvider,
    public override tcrApi: TouchcrApiGeneralExtenderProvider,
    public override tcrApiOrder: TouchcrApiOrderExtenderProvider,
    public override tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public override toastCtrl: ToastController,
    public override eventStreamer: EventStreamerProvider,
    public override tcrApiLead: TouchcrApiLeadProvider,
    public override tcrApiCoupon: TouchcrApiCouponProvider,
    public override orderDetails: OrderDetailsProvider,
    public override paypalPayment: PaypalPaymentExtenderProvider,
    public override ngZone: NgZone,
    public override shippingProvider: TouchcrApiShippingProvider,
    public override calculateHelper: CalculateProvider,
    public override urlsHelper: UrlsProvider,
    public override orderHelper: OrderProvider,
    public override orderHelperExtender: OrderProviderExtender,
    public override stateProvider: StateProvider,
    public override general: GeneralProvider,
    public override funnelProvider: FunnelSettingsProvider,
    public override spinner: SpinnerProvider,
    public override location: PlatformLocation,
    public override loggingProvider: LoggingProvider,
    public override currencyPipe: CurrencyPipe,
    public override router: Router,
    public override dynamicCurrencyPipe: DynamicCurrencyPipe,
    public override storage?: Storage
  ) {
    super(
      navCtrl,
      sanitizer,
      tcrApiOrderform,
      cart,
      tcrApi,
      tcrApiOrder,
      tcrApiRemoteServices,
      toastCtrl,
      eventStreamer,
      tcrApiLead,
      tcrApiCoupon,
      orderDetails,
      paypalPayment,
      ngZone,
      shippingProvider,
      calculateHelper,
      urlsHelper,
      orderHelper,
      orderHelperExtender,
      stateProvider,
      general,
      funnelProvider,
      spinner,
      location,
      loggingProvider,
      currencyPipe,
      router,
      dynamicCurrencyPipe,
      storage
    );
  }

  override ngOnInit() {
    super.ngOnInit();
    this.isShowBumpOffer();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.showMysteryGift) {
      this.startTimer();
    }
  }
  
  //Use this method to set up initial values for template variables
  override populatePageData() {
    let body = document.getElementsByTagName('body')[0];
    body.setAttribute('data-qa','checkout-page');

    this.brandLogo = this.CDN_IMAGES.LOGO_WHITE;
    this.blueLogo = this.CDN_IMAGES.LOGO;
    this.headerText = '';
    this.showOnOrderForm = true;
    this.guaranteeBadge = this.CDN_IMAGES.CHECKOUT_60DAY;
    this.unitsSoldIcon = this.CDN_IMAGES.UNITS_SOLD;
    this.shippingIcon = this.CDN_IMAGES.CHECKOUT_TRUCK;
    this.tryFreeIcon = this.CDN_IMAGES.TRY_FREE_ICON;
    this.tryJarIcon = this.CDN_IMAGES.TRY_JAR_ICON;
    this.tryRenewIcon = this.CDN_IMAGES.TRY_RENEW_ICON;
    this.returnIcon = this.CDN_IMAGES.RETURN_ICON;
    this.giftIcon = this.CDN_IMAGES.GIFT_ICON;
    this.calendarIcon = this.CDN_IMAGES.CALENDAR_ICON;
    this.heartIcon = this.CDN_IMAGES.HEART_ICON;
    this.chevronDownIcon = this.CDN_IMAGES.CHEVRON_DOWN_ICON;

    this.setDynamicCustomerServiceInfo();

    if (this.braintreeDefaultCountry && this.braintreeDefaultCountry == 'Germany') {
      this.headerText = `<h2>KUNDENDIENST</h2><p>+1-${CUSTOMER_SERVICE_PHONE_NUMBER} | MF 7:00–17:00 UHR PST | SS 7:00–16:00 UHR PST</p>`;
    } else if (this.braintreeDefaultCountry && this.braintreeDefaultCountry == 'Mexico') {
      this.headerText = `<h2>Servicio al cliente</h2><p>+1-${CUSTOMER_SERVICE_PHONE_NUMBER} |M-F 7AM-5PM PST | S-S 7AM-4PM PST</p><p>servicioalcliente@beverlyhillsmd.com</p>`;
    } else {
      if(this.braintreeDefaultCountry && this.braintreeDefaultCountry != 'United States' ) {
      this.headerText = '<br><h2>CUSTOMER SERVICE</h2>' +
        `<p>${this.dynamicPhoneNumber }<br>${this.dynamicCustomerServiceHours}</p>`;
      } else {
        this.headerText = '<h2>Agents standing by to help</h2>' +
        `<p>877-828-5528</p>`;
      } 
    }
    this.showOnOrderForm = true;
  }

  override async payPalAddressHandler(payload: any) {
    console.log('[GH] payPalAddressHandler v2 - issue with email validation that did not happen in the original checkout-common');
    await super.payPalAddressHandler(payload);
    try {
      if (this.accountForm?.form?.controls?.email) {
        this.accountForm.form.controls.email.updateValueAndValidity(); // DEV-46966
      }
    } catch (error) {
      console.error('[GH] Error updating email validity:', error);
    }
  }

  showReturnPolicyModal: boolean = false;
  expandedSections: { [key: string]: boolean } = {
    returnPolicy: false,
    howToReturn: false
  };

  openReturnPolicyModal(event: Event) {
    event.preventDefault();
    this.showReturnPolicyModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeReturnPolicyModal(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    this.showReturnPolicyModal = false;
    document.body.style.overflow = 'auto';
  }

  toggleCollapsible(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  // Timer methods
  startTimer() {
    this.initializeTimer();
    this.createTimer();
  }

  initializeTimer() {
    this.nowsDate = new Date();
    this.timerDate = JSON.parse(localStorage.getItem('timerDate') || 'null');
    
    if (!this.timerDate) {
      // We save current date in localStorage
      localStorage.setItem('timerDate', JSON.stringify(this.nowsDate));
      this.totalTimeInSeconds = 300; // 5 minutes
      this.showMysteryGift = true;
    } else {
      // If there is already a timer in localStorage, we calculate the elapsed time
      let elapsedSeconds = Math.floor((this.nowsDate.getTime() - new Date(this.timerDate).getTime()) / 1000);
      this.totalTimeInSeconds = Math.max(0, 300 - elapsedSeconds); // 5 minutes minus elapsed time
      
      // If timer has already expired, hide the mystery gift
      if (this.totalTimeInSeconds <= 0) {
        this.showMysteryGift = false;
        localStorage.removeItem('timerDate');
        return; // Don't start the timer if it's already expired
      }
    }
    
    this.updateTimerDisplay();
  }

  createTimer() {
    this.timerInterval = setInterval(() => {
      this.totalTimeInSeconds = Math.max(0, this.totalTimeInSeconds - 1);
      this.updateTimerDisplay();
      
      if (this.totalTimeInSeconds <= 0) {
        this.stopTimer();
        this.showMysteryGift = false;
        localStorage.removeItem('timerDate');
      }
    }, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  updateTimerDisplay() {
    const minutes = Math.floor(this.totalTimeInSeconds / 60);
    const seconds = Math.floor(this.totalTimeInSeconds % 60);
    
    this.minutes = minutes.toString(); // Single digit without padding
    // Split seconds into tens and ones digits
    const secondsStr = seconds.toString().padStart(2, '0');
    this.secondsTens = secondsStr[0];
    this.secondsOnes = secondsStr[1];
  }

  clearTimer() {
    this.stopTimer();
    this.showMysteryGift = false;
    localStorage.removeItem('timerDate');
  }

  isShowBumpOffer() {
    const showBumpOffer = CookieUtils.getCookie('showBumpOffer');
    if (showBumpOffer === 'true') {
      this.bumpOfferOn = true;
      this.trialDays = this.funnel?.product?.trialDays ?? 21;
    } else {
      this.bumpOfferOn = false;
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.stopTimer();
  }
} 